import ProgressReportListView from './component';
import _routes from './routes';

export const routes = _routes;
export default ProgressReportListView;



// WEBPACK FOOTER //
// ./containers/Group/ProgressReport/ProgressReportListView/index.js